var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"app-icon",class:{ 'app-icon--outlined': _vm.outlined }},[(_vm.icon)?_c('span',{staticClass:"app-icon__img",style:(_setup.iconStyle),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }